import $ from "jquery";
import inView from "in-view";
import anime from "animejs";

inView.offset(window.innerHeight / 6);

inView(".block-elm").on("enter", el => {
  $(el).addClass("in-view-complete");
});
